<template>
	<div
		class="d-flex align-items-center justify-content-center"
		:style="{'font-size': size[0] || '14px' , 'color': (color ? color : $colors['dark-gray-3'])}"
		:class="textClasses"
	>
		<fa-icon
			v-if="icon"
			:icon="icon"
			:style="{'font-size': size[1] || '22px'}"
			class="mr-2"
			:class="iconClasses"
		/> <slot />
	</div>
</template>

<script>
export default {
	name: 'GCaption',
	props: {
		// TEXT
		text: {
			type: String,
			default: ''
		},
		size: {
			type: Array,
			default: () => ['14px', '22px']
		},
		textClass: {
			type: String,
			default: ''
		},
		// ICON
		icon: {
			type: Array,
			default: null
		},
		iconClass: {
			type: String,
			default: ''
		},
		// OTHERS
		orientation: {
			type: String,
			default: 'row'
		},
		horizontal: {
			type: Boolean,
			default: false
		},
		vertical: {
			type: Boolean,
			default: true
		},
		animated: {
			type: String,
			default: null
		},
		infinite: {
			type: Boolean,
			default: false
		},
		faster: {
			type: Boolean,
			default: false
		},
		delay: {
			type: Number,
			default: 1
		},
		color: {
			type: String,
			default: null
		}
	},
	computed: {
		iconClasses() {
			let className = this.iconClass;
			if (this.animated) {
				className += ` animate__animated ${this.infinite ? 'animate__infinite' : ''} ${this.faster ? 'animate__faster' : ''} animate__${this.animated} animate__delay-${this.delay}s`;
			}

			if (this.vertical) {
				className += ' mb-2';
			}

			return className;
		},
		textClasses() {
			if (this.horizontal) {
				return `flex-row ${this.textClass}`;
			}

			if (this.vertical) {
				return `flex-column ${this.textClass}`;
			}

			return this.textClass;
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
